module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter42"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block58"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "h159"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("Saylor")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p2790"
    }
  }, [_vm._v("My phone vibrates repeatedly on my kitchen counter, causing it to move as if there were an army of ants underneath it. I glance at the clock on my microwave before picking it up. The motto at work is that it’s never too early to start working. Unfortunately, being a single mom, that isn’t how I can function. My daughter comes first, and my employer is very aware of this fact.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2791"
    }
  }, [_vm._v("Except this morning seems to be different. A quick swipe and his text message, along with numerous others from my co-workers, appears on my screen. The message is simple: "), _c('span', {
    staticClass: "ecom-char-hbg"
  }, [_vm._v("Get to work ASAP")]), _vm._v(". That’s code for something, and likely something has happened to one of our clients. It could be anything from a Good Samaritan deed, the birth of a child, a divorce, or the type of publicity I don’t like to deal with, accusations for rape, murder, and the like.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2792"
    }
  }, [_vm._v("Being a public relations specialist has its perks. If I want to attend a sporting event, I call my client. If I need to woo the pants off a prospective client, I set them up with a luxury suite at whatever game they want to attend. And as with any job, it also has a downside. My hours are long, the job is never ending, and sometimes I feel like a babysitter. But I wouldn’t trade what I do for anything. My clients and co-workers have become my family.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2793"
    }
  }, [_vm._v("Lucy, my five-year-old daughter, comes sashaying into the room, dressed as her favorite princess for her school’s character festival today. Her blue Cinderella dress is one that we bought last year from Disneyland, along with her matching tiara.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2794"
    }
  }, [_vm._v("“Well, don’t you look like a pretty princess?” Crouching down so we’re eye level, I push a lock of hair back up into the bun she attempted to do on her own.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2795"
    }
  }, [_vm._v("“Cinderella doesn’t have brown hair,” Lucy tells me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2796"
    }
  }, [_vm._v("“No, I suppose she doesn’t, but that’s the best part about make-believe. You can make her look like anything you want.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2797"
    }
  }, [_vm._v("The smile she gives me feels like I’ve won Mother of the Year, even though I feel far from it. I struggle emotionally when it comes to Lucy. Her father, my ex, has wanted nothing to do with her until yesterday. I haven’t heard a peep from him since the day I told him I was pregnant, and now he’s asking to see her. It would be easy to say yes and give Lucy the answers to all her questions. Hell, I want answers, too. I’m like her. I want to know why her father hasn’t wanted to see her. But I don’t trust him. If he could so easily dismiss her before she was born, what’s to say he won’t do the same after he meets her?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2798"
    }
  }, [_vm._v("Deep down, I feel it has to do with his wife and the family they’ve started. Some of my clients are in constant battles with their exes, and it’s never pretty. Most importantly, I want to know why now, after all this time, he’s interested in Lucy.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2799"
    }
  }, [_vm._v("“Have you brushed your teeth?” Lucy nods. “Okay, let’s get ready to go.” I kiss her on her nose before she runs off. I can hear her singing “Bibbidi-Bobbidi-Boo” and getting only a few of the words right.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2800"
    }
  }, [_vm._v("Slipping my phone into my messenger bag, my hand brushes against the envelope that brought me to my knees yesterday. I intercepted the handwritten letter about Lucy that has the power to ruin everything I’ve built. I thought I could go to the bar and seek comfort in an old friend, but I was mistaken. Holding the glass with two fingers of Scotch only reminded me of the hell I’ve been through. I purposely ordered liquor that I can’t stomach, hoping that it’d curb my desire to drink. It didn’t. A man in the bar did.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2801"
    }
  }, [_vm._v("Once I saw Travis Kidd standing next to me, I knew I had to get out of there. He’s trouble—he knows it, and I know it. I’ve been down this road with him before, and I’ve determined that he’s not worth my career. One mistake with him led to a long line of legal troubles for me. My employment agreement states that I will stay away from the athletes, despite how appealing they can be, and the indiscretion with Travis nearly cost me everything.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2802"
    }
  }, [_vm._v("Lucy comes out of her room, ready to go. Her tiara has been replaced with a knit cap to keep her head warm, and her fingers are covered in mittens. It’s chilly, but not overly cold at the moment. Although the cold weather is right around the corner, and that isn’t something I’m looking forward to. Winters in Boston can be brutal.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2803"
    }
  }, [_vm._v("Walking hand in hand, Lucy and I make our way to her school. It’s only a few blocks from our apartment and close to the subway, which makes it easy for me to get to work, because my office is only two stops away. I remind Lucy that her grandmother will pick her up from school today and tell her to be good before I make sure she’s in the hands of her teacher.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2804"
    }
  }, [_vm._v("Now that she’s in school, my mode switches to work. With my phone in hand, I’ve quickly become one of those people who walk and text at the same time. I look up periodically to make sure I’m not about to be run over or, better yet, crash into someone while I answer what feels like a hundred messages.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2805"
    }
  }, [_vm._v("As soon as I step into the office, the assistant I share with my boss takes my coat and bag and tells me that my boss is waiting. Stepping into Jeffrey Tay’s office is like walking into a sports museum. His walls are covered with pictures of him and most of his clients. Jeffrey motions for me to sit down as he continues his phone call. He pinches the bridge of his nose while pacing back and forth, agreeing to whatever is being said on the other line.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2806"
    }
  }, [_vm._v("“Fuck,” he roars, throwing his headset across the room. The somewhat flimsy product lands with a loud thump against the wall, causing me to jump. Jeffrey faces the large window that overlooks the Boston Harbor and laces his fingers behind his head. By the shudder in his shoulders, I can tell he’s let out a sigh or maybe even two. “Travis Kidd needs our help.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2807"
    }
  }, [_vm._v("The mere mention of Travis’s name has me feeling uneasy and uncrossing and crossing my legs to find a bit of comfort. While Jeffrey continues to stare out the window, last night’s encounter runs through my mind. Nothing I said last night, or any actions on my part, could be construed as a violation of my employment contract. Only my actions years earlier, but I’ve kept those under wraps.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2808"
    }
  }, [_vm._v("Then I remember what Jeffrey said, and that Travis Kidd needs"), _c('i', [_vm._v(" our")]), _vm._v(" help, and that seems to quell a bit of the building anxiety. He’s done something that has Jeff visibly upset, which means it’s going to be a lot of work for me. But it means that my secret is still safe.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2809"
    }
  }, [_vm._v("I’m afraid to ask what he’s done. The list running through my mind right now is a mile long. It could be drinking and driving, although I saw him get into the cab last night and watched it leave. Assault is always a possibility. Or maybe he was drunker than I thought and he wound up walking into the wrong house. It’s bound to happen and, unfortunately, is an action we, in the business of sports management, have had to deal with, especially in the off-season.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2810"
    }
  }, [_vm._v("Regardless of the situation or how I feel about this particular client, I have a job, and I take immense pride in it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2811"
    }
  }, [_vm._v("“What’s he done?” I almost add “this time” to the end of my question but that would be unfair to Travis. Yes, he’s wild and a publicity nightmare but he’s rarely in trouble. I can usually put a positive spin on his actions, and while some may be questionable, I make him look like a saint. I was able to turn one of his dumbest ideas—of opening a kissing booth outside of Faneuil Hall and charging five dollars—into a massive fund-raiser for the children’s hospital. Even though he gave me little warning, one phone call to the local radio station had women lining up for hours. The donations poured in, and at the end of the night, he was the town’s hero again.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2812"
    }
  }, [_vm._v("Jeffrey turns, and the turmoil on his face tells me that it’s something bad. Reaching for the pad of paper and a pen that I see on his desk, I prepare to take notes.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2813"
    }
  }, [_vm._v("“That was Irvin Abbott on the phone.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2814"
    }
  }, [_vm._v("“Travis’s lawyer?” I ask, interrupting Jeffrey.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2815"
    }
  }, [_vm._v("Jeffrey makes eye contact quickly, telling me that he doesn’t appreciate the interruption. “He called to let me know that Kidd voluntarily went to the police station after being visited this morning. It seems that he’s being accused of rape.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2816"
    }
  }, [_vm._v("I swallow hard as I listen to Jeffrey’s words. That means that Travis went somewhere else last night. The woman he was with at the bar seemed rather put off that he was speaking to me. I can’t imagine she would have given him the time of day after the way he brushed her off.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2817"
    }
  }, [_vm._v("Jeffrey sighs, running his hand through his hair before sitting down and resting his face in his hands.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2818"
    }
  }, [_vm._v("“This isn’t our first accusation of rape,” I remind him, although it’s the first for Travis.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2819"
    }
  }, [_vm._v("“No, it’s not, but this is Travis Kidd. His antics alone, his habits and the lifestyle he leads, have made him a prime suspect, and according to Abbott, the district attorney is ready to throw the book at him. You can bet that the media will be all over this. The DA is always looking to have his face in front of the cameras.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2820"
    }
  }, [_vm._v("“Was he arrested?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2821"
    }
  }, [_vm._v("Jeffrey shakes his head. “Not yet, according to Abbott. He got the call from Kidd and went right there. He called me on the way, telling me what he knew. Kidd is saying he’s innocent and has an alibi who can testify that he left the bar by himself.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2822"
    }
  }, [_vm._v("My throat swells, and my palms begin to sweat. “Did he say who?” I croak through my question. Relief washes over me as Jeffrey shakes his head. I may have been in the cab with Travis but didn’t stay, and the woman at the bar got into a car before I walked off. That doesn’t mean he didn’t circle back, though. And that doesn’t mean I’m his alibi.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2823"
    }
  }, [_vm._v("“Abbott indicated that Kidd wants to speak to this person before he gives the police their name.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2824"
    }
  }, [_vm._v("“And I gather the police aren’t that easily swayed?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2825"
    }
  }, [_vm._v("Jeffrey’s lips go into a fine line as he shakes his head. “Unfortunately no.” He stands and moves to the far wall, looking at the framed images. “I need you to go down there for the press conferences. The DA is hungry. It’s an election year, and Kidd handed him the case of the decade. Abbott is planning his own press conference to plead Kidd’s case to the public. The people of Boston love him, and we need the fan support. Stand with Abbott and protect Kidd.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2826"
    }
  }, [_vm._v("As much as I want to tell Jeffrey no, I can’t, it’s my job, despite how I feel about this particular client. What Travis and I shared was a mistake, and I vowed to never let anything like that happen again. I’ve made good on my promise, and I refuse to let anything come between my job and me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2827"
    }
  }, [_vm._v("I’m excused from Jeffrey’s office and head to my own. I don’t have much time to do anything except ask my assistant to clear my schedule for the day. A quick glance at my calendar tells me that it’s five meetings that she’ll have to move, three of which are new clients. I ask her to reschedule them for tomorrow and make the necessary travel arrangements for those who aren’t local.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2828"
    }
  }, [_vm._v("Jeffrey was right. By the time I reach the police station, the media is lingering around, waiting for someone to come out and talk to them. My name is called out, asking for a comment as I pass by, and I ignore each and every reporter. They know better than to ask, but they wouldn’t be doing their job if they didn’t. I run smack into Paul Boyd from ESPN, falling off-balance until he catches me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2829"
    }
  }, [_vm._v("“Thanks, Paul,” I say, straightening my clothes. I offer him a soft smile and sidestep to go by him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2830"
    }
  }, [_vm._v("“Hold up, Saylor.” I shake my head and take another step toward the entrance, only to be halted.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2831"
    }
  }, [_vm._v("“What do you know?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2832"
    }
  }, [_vm._v("This is where the sports business is tricky. If I need something to be leaked, I make a few phone calls, and any one of my clients is front-page news. The media wants something in return, so they expect the same from me. I can’t work like that. The privacy of my clients is first and foremost for me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2833"
    }
  }, [_vm._v("“You know I can’t say anything, Paul.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2834"
    }
  }, [_vm._v("“Did he do it?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2835"
    }
  }, [_vm._v("I look away, fearful that my eyes will tell him something when my mind and heart mean something else. “Wait for Abbott’s press conference.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2836"
    }
  }, [_vm._v("“Wait—we were told only the DA is making a statement.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2837"
    }
  }, [_vm._v("I look over Paul’s shoulder and frown. It seems as if the state is already trying to manipulate the news with only one sports outlet being on-site.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2838"
    }
  }, [_vm._v("“Abbott’s having one. Spread the word for me, okay?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2839"
    }
  }, [_vm._v("“What’s in it for me?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2840"
    }
  }, [_vm._v("This is the nature of the beast in this business. You scratch my back, and I’ll scratch yours. Pushing my hands deep into my jacket pockets, I shrug. “You can have the first public interview that Kidd gives.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2841"
    }
  }, [_vm._v("I don’t wait for Paul to agree before making my way up the last few stairs to enter the police station. The desk sergeant knows why I’m here and motions for me to walk down the hall after telling me they’re in room five. I knock and enter. Both Travis and Abbott’s eyes are on me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p2842"
    }
  }, [_vm._v("“Travis is in trouble,” Abbott says. Those are the last words I expected to hear when I walked in.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2882a67e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s006-Chapter-002.vue
// module id = 75
// module chunks = 0